import axios from "axios";
import config from "../config";

interface LoggedInResponse {
  loggedIn: boolean;
}

// Key used to prevent redirect loops within the same browser tab session.
// Set before redirecting to Cognito; cleared on successful login.

export default async function TestLogin(redirectLoginUrl: string = null) {
  let isLoggedIn = false;

  if (!config.useFakeModels) {
    try {
      const response = await axios.get<LoggedInResponse>(
        config.testLoginEndpoint,
      );
      console.log("TestLogin status:", response.status);
      console.log("TestLogin response:", response.data);
      console.log("TestLogin response is Logged in:", response.data.loggedIn);
      if (response?.data?.loggedIn) {
        isLoggedIn = true;
      } else if (redirectLoginUrl != null) {
        console.log(
          "User is not logged in. Redirecting to login page with redirectLoginUrl:",
          redirectLoginUrl,
        );
        const redirectUrl =
          config.loginBaseUrl +
          "&state=" +
          encodeURIComponent(redirectLoginUrl);

        console.log("Redirecting to login page: " + redirectUrl);

        window.location.href = redirectUrl;
      }
    } catch (e) {
      if (redirectLoginUrl != null) {
        console.log(
          "User is not logged in. Redirecting to login page with redirectLoginUrl:",
          redirectLoginUrl,
        );
        const redirectUrl =
          config.loginBaseUrl +
          "&state=" +
          encodeURIComponent(redirectLoginUrl);

        console.log("Redirecting to login page: " + redirectUrl);

        window.location.href = redirectUrl;
      }
      // On network error, do NOT redirect — show the unauthenticated state instead
      // to avoid a redirect loop triggered by a transient infrastructure issue.
      console.error("There was an error!", e);
    }
  } else {
    isLoggedIn = true;
  }

  return isLoggedIn;
}
